module.exports = __webpack_public_path__ + "static/img/30017 (4).d05e2aa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30017 (4).webp
// module id = OPhB
// module chunks = 14